<app-info-modal [infoModalData]="infoModalData">
  <app-apps-buttons-group></app-apps-buttons-group>
</app-info-modal>
